import { styled, Box } from '@mui/material'
import Image from 'next/image'

export const LayoutWrapper = styled(Box)`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`

export const BgImage = styled(Image)`
  object-fit: cover;
  object-position: left;
  width: 100%;
  height: 100%;
`

export const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  width: 100%;
  min-width: 50%;
`
